<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 24 23"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle r="10" transform="matrix(-1 0 0 1 12 11)" :fill="background" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M21 11.5C21 10.3674 20.7672 9.2458 20.3149 8.19937C19.8626 7.15293 19.1997 6.20212 18.364 5.40121C17.5282 4.60031 16.5361 3.965 15.4442 3.53155C14.3522 3.0981 13.1819 2.87501 12 2.87501C10.8181 2.87501 9.64778 3.0981 8.55585 3.53155C7.46392 3.965 6.47177 4.60031 5.63604 5.40121C4.80031 6.20212 4.13737 7.15293 3.68508 8.19937C3.23279 9.2458 3 10.3674 3 11.5C3 13.7875 3.94821 15.9813 5.63604 17.5988C7.32387 19.2163 9.61305 20.125 12 20.125C14.3869 20.125 16.6761 19.2163 18.364 17.5988C20.0518 15.9813 21 13.7875 21 11.5ZM12 0.958344C18.075 0.958344 23 5.67814 23 11.5C23 17.3219 18.075 22.0417 12 22.0417C5.925 22.0417 1 17.3219 1 11.5C1 5.67814 5.925 0.958344 12 0.958344ZM9.293 7.38589C9.11084 7.20514 9.01005 6.96306 9.01233 6.71179C9.0146 6.46052 9.11977 6.22016 9.30518 6.04248C9.49059 5.86479 9.7414 5.76401 10.0036 5.76182C10.2658 5.75964 10.5184 5.85623 10.707 6.0308L15.707 10.8225C15.8945 11.0022 15.9998 11.2459 15.9998 11.5C15.9998 11.7541 15.8945 11.9978 15.707 12.1776L10.707 16.9692C10.5184 17.1438 10.2658 17.2404 10.0036 17.2382C9.7414 17.236 9.49059 17.1352 9.30518 16.9575C9.11977 16.7799 9.0146 16.5395 9.01233 16.2882C9.01005 16.037 9.11084 15.7949 9.293 15.6141L13.586 11.5L9.293 7.38589Z"
			:fill="border"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		border: {
			default: '#597393',
		},
		background: {
			default: '#F2F7F9',
		},
		size: {
			default: 24,
		},
	},
};
</script>
